/**
 * Keeps the browser chrome colour in sync with the design tokens, so no hex
 * value has to be repeated in index.html.
 *
 * There is no dark mode to follow (REDESIGN.md §3): the app is light by
 * identity, so this reads --bg once and is done. If a theme ever returns, this
 * is the one place that has to learn about it.
 */

function ensureMeta() {
  let meta = document.querySelector('meta[name="theme-color"]')

  if (!meta) {
    meta = document.createElement('meta')
    meta.name = 'theme-color'
    document.head.append(meta)
  }

  return meta
}

export function syncThemeColor() {
  const background = getComputedStyle(document.documentElement).getPropertyValue('--bg').trim()

  if (background) {
    ensureMeta().setAttribute('content', background)
  }
}
